import { SuggestiveDropdownProps } from '@ahc-digital/component-library';
import { C10SuggestiveDropdownListProps } from './C10SuggestiveDropdownList.types';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { useI18n } from 'next-localization';
export function CreateSuggestiveDropDownListModel(props?: C10SuggestiveDropdownListProps) {
  const { params, fields } = props || {};
  const { renderText, renderRichText, renderLink } = useConditionalRendering();
  const { t } = useI18n() || {};
  type t = SuggestiveDropdownProps;
  const links = fields?.suggestiveDropdown?.listOfLinks?.Links?.value;

  return {
    headline: renderText(fields?.suggestiveDropdown?.headline) as t['headline'],
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'left'),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.Background, 'whiteSmoke'),
    supportCopy: renderRichText(fields?.suggestiveDropdown?.supportCopy) as t['supportCopy'],
    cta: renderLink(fields?.suggestiveDropdown?.cTA, {
      editable: false,
    }) as t['cta'],
    placeholderText: t('SuggestiveDropdownList-PlaceholderText'),
    submitButtonText: t('SuggestiveDropdownList-SubmitButtonText'),
    labelText: t('SuggestiveDropdownList-LabelText'),
    links:
      ((links?.length ?? 0) > 0 &&
        links?.map((linkFieldValue) => {
          return {
            text: linkFieldValue.text ?? '',
            href: linkFieldValue.href ?? '',
            target: linkFieldValue.target ?? '_self',
          };
        })) ||
      ([] as SuggestiveDropdownProps['links']),
  };
}
